import { render, staticRenderFns } from "./ClicMarkdownInterno.vue?vue&type=template&id=7cf41cd8&"
import script from "./ClicMarkdownInterno.vue?vue&type=script&lang=js&"
export * from "./ClicMarkdownInterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports